/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import api, {
  multiPartHeader, 
  partHeader, 
  apiInternal, apiFiles
 } from '../../api';

const moment = require('moment');
const FileDownload = require('js-file-download');

moment().format();

const state = {
  all: [],
  troubleshoots: [],
  tags: [],
  trainingLessons: [],
  modules: [],
  devices: [],
  services: [],
  perimeters: [],
  unassociated: [],
  statsEstablishments: [],
  statsEstablishment: [],
  statsDetailsEstablishment: [],
  establishmentLogistic: null,
  establishmentManage: null,
  establishmentPatGames: null,
  slidingPeriodStatsEstablishments: 1, // 1 or 2
};

const getters = {
  establishmentById: state => id => state.all.find(establishment => establishment.esta_id === id),
  devicesByEstaId: state => id => state.devices[id],
  servicesByEstaId: state => id => state.services[id],
};

const actions = {
  async getAllEstablishments({ commit }) {
    const result = await api.post(`${apiInternal}/getEstablishments`,{},partHeader);
    if (result) commit('setEstablishments', result.data);
    return result;
  },
  async getAllTroubleshoots({ commit }) {
    const result = await api.post(`${apiInternal}/getTroubleshoots`,{},partHeader);
    if (result) commit('setTroubleshoots', result.data);
    return result;
  },
  async getUnassociatedEstablishments({ commit }) {
   const result = await api.post(`${apiInternal}/getUnassociatedEstablishments`,{},partHeader);
    if (result) commit('setUnassociatedEstablishments', result.data);
    return result;
  },
  async getEstablishmentById({ state, commit }, estaId) {
   const result = await api.post(`${apiInternal}/getEstablishment`,{ esta_id: estaId },partHeader);
    if (result) commit('updateEstablishment', result.data);
    return result;
  },
  async addEstablishment({ state, commit }, establishment) {
    const result = await api.post(`${apiInternal}/SetEstablishment`,establishment,partHeader);
    if (result) commit('updateEstablishment', result.data);
    return result;
  },
  async importEstablishment({ state, commit }, [contId, formList]) {
    formList.append('cont_id', contId); 
    const result = await api.post(`${apiInternal}/ImportEstablishment`,formList,multiPartHeader);
   return result;
  },
  async getStatsEstablishments({ state, commit }) {
    const period = `${moment().subtract(state.slidingPeriodStatsEstablishments, 'month').format('YYYY-MM-')}01`;
    const result = await api.post(`${apiInternal}/getstatsEstablishments`,{ period },partHeader);
    if (result) commit('setStatsEstablishments', result.data);
    return result;
  },
  async getStatsEstablishment({ state, commit }, estaId) {
    const period = `${moment().subtract(4, 'month').format('YYYY-MM-')}01`;
    const result = await api.post(`${apiInternal}/getstatsEstablishments`,{ period, esta_id: estaId  },partHeader);
    if (result) commit('setStatsEstablishments', result.data);
    return result;
  },
  async getStatsDetailsEstablishment({ state, commit }, estaId) {
    const period = `${moment().subtract(4, 'month').format('YYYY-MM-')}01`;
    const result = await api.post(`${apiInternal}/getstatsDetailsEstablishment`,{ period, esta_id: estaId  },partHeader);
    if (result) commit('setStatsDetailsEstablishment', result.data);
    return result;
  },
  // async exportStatEsta({ state, commit }, estaId) {
  //   const result = await api.post(`${apiInternal}/exportStatEstablishment`,{ esta_id: estaId }, { ...partHeader, ...{responseType: 'blob'} });
  //   if (result) FileDownload(result.data, 'Statistiques.xlsx');
  //   return result;    
  // },
  // async getAppDeviceVersion() {
  //   const result = await api.post(`${apiInternal}/getAppDeviceVersion`,{ }, { ...partHeader, ...{responseType: 'blob'} });
  //   if (result) FileDownload(result.data, 'Données tablettes clients Anisen.xlsx');
  //   return result;    
  // },
  async getSettingsModule({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getSettingsModule`,estaId,partHeader);
    if (result) commit('setModuleEstablishments', { estaId, modules: result.data});
    return result;
  },
  async getServices({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getServices`,{esta_id:estaId},partHeader);
    if (result) commit('setEstablishmentService', { estaId, services:result.data});
    return result;
  },
  async getDevices({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getDevices`,{esta_id:estaId},partHeader);
    if (result) commit('setEstablishmentDevices', { estaId, devices:result.data});
    return result;
  },
  async getPerimeters({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getAllowedPerimeters`,{esta_id:estaId},partHeader);
    if (result) commit('setEstablishmentPerimeters', { estaId, perimeters:result.data});
    return result;
  },
  async getTags({ state, commit }) {
    const result = await api.post(`${apiInternal}/getTags`,{},partHeader);
    if (result) commit('setTags', result.data);
    return result;
  },
  async getTrainingLessons({ state, commit }) {
    const result = await api.post(`${apiInternal}/getTrainingLessons`,{},partHeader);
    if (result) commit('setTrainingLessons', result.data);
    return result;
  },
  async deleteTrainingLesson({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/DeleteTrainingLesson`,params,partHeader);
    if (result) commit('setTrainingLessons', result.data);
    return result;
  },
  async removeTag({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/removeTag`,params,partHeader);
    return result;
  },
  async setTag({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/setTag`,params,partHeader);
    if (result) commit('setTags', result.data);
    return result;
  },
  async setTrainingLesson({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/setTrainingLesson`,params,partHeader);
    return result;
  },
  async getBase64Icon({ state, commit }, assId) {
    const result = await api.post(`${apiFiles}/GetBase64File`, { id: [assId], source: 'tmasset' },partHeader);
    return result;
  },
  async setModuleStatus({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/setModuleStatus`,params,partHeader);
    return result;
  },
  async resetModuleSettings({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/resetModuleDefaultSettings`,params,partHeader);
    return result;
  },
  async importEstablishmentSetting({ state, commit }, [estaId, formList]) {
    formList.append('esta_id', estaId);
    const result = await api.post(`${apiInternal}/importEstablishmentSetting`,formList,multiPartHeader);
    return result;
  },
  async setService({ state, commit }, formService) {
    const result = await api.post(`${apiInternal}/setService`, formService,partHeader);
    return result;
  },
  async reportTroubleshoot({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/reportTroubleshoot`,params,partHeader);
    return result;
  },
  async closeConnectionDevice({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/closeConnectionDevice`,params,partHeader);
    if (result) commit('updateDeviceConnection', params.dev_id);
    return result;
  },
  async cancelTroubleshoot({ state, commit }, params) {
    const result = await api.post(`${apiInternal}/cancelTroubleshoot`,params,partHeader);
    if (result) commit('updateTroubleshoot', params.tbs_id);
    return result;
  },
  changeSlidingPeriodStatsEstablishments({ state, commit }, period) {
    commit('changeSlidingPeriodStatsEstablishments', period);
  },
};

const mutations = {
  setEstablishments(state, establishments) {
    state.all = establishments;
  },
  setTroubleshoots(state, troubleshoots) {
    state.troubleshoots = troubleshoots;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setTrainingLessons(state, trainingLessons) {
    state.trainingLessons = trainingLessons;
  },
  setModuleEstablishments(state, { estaId, modules }) {
    state.modules.push(estaId.esta_id);
    state.modules[estaId] = modules;
  },
  setEstablishmentService(state, { estaId, services }) {
    state.services.push(estaId.esta_id);
    state.services[estaId] = services;
  },
  setEstablishmentDevices(state, { estaId, devices }) {
    state.devices.push(estaId.esta_id);
    state.devices[estaId] = devices;
  },
  setEstablishmentPerimeters(state, { estaId, perimeters }) {
    state.perimeters.push(estaId.esta_id);
    state.perimeters[estaId] = perimeters;
  },
  setUnassociatedEstablishments(state, establishments) {
    state.unassociated = establishments;
  },
  addEstablishment(state, establishment) {
    state.all.push(establishment);
  },
  updateEstablishment(state, newEstablishment) {
    const index = state.all.findIndex(establishment => establishment.esta_id === newEstablishment.esta_id);
    if (index >= 0) {
      state.all.splice(index, 1, newEstablishment);
    } else {
      state.all.push(newEstablishment);
    }
    // TODO : set date properly
  },
  updateTroubleshoot(state, tbsId) {
    const trouble = state.troubleshoots.find(troubleshoot => troubleshoot.tbs_id === tbsId);
    trouble.tbs_status = 'CANCEL';
  },
  updateDeviceConnection(state, devId) {
    for (let i = 0; i < state.devices.length; i += 1) {
      const devices = state.devices[i];
      if (typeof devices !== 'undefined') {
        const device = devices.find(d => d.dev_id === devId);
        device.dev_state = false;
      }
    }
  },
  setStatsEstablishments(state, establishments) {
    establishments.forEach((e) => {
      e.participants = `${e.nbinvolvedparticipantsperiod}/${e.nballparticipants}`;
      e.reports = `${e.nbfinishedreports}/${e.nballreports}`;
      e.avglastsyn = e.avglastsyn ? parseInt(e.avglastsyn, 10) : '-';
      // logistique
      if (e.avglastsyn !== '-' && e.avglastsyn < 15 && e.nbsyncdevices === e.nballdevices) {
        e.logistic = 'green';
      } else if ((e.avglastsyn !== '-' && e.avglastsyn >= 15 && e.avglastsyn <= 30) || (e.nballdevices > 0 && e.nbsyncdevices / e.nballdevices >= 0.5)) {
        e.logistic = 'orange';
      } else if (e.avglastsyn === '-' || (e.avglastsyn > 30) || (e.nballdevices > 0 && e.nbsyncdevices / e.nballdevices < 0.5)) {
        e.logistic = 'red';
      }

      if (e.off_name === 'CLESIA' || (e.off_name).toUpperCase() === 'TOUT') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports === 0 || (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5)) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      } else if (e.off_name === 'PANACE') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      } else if (e.off_name === 'EGLE') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      }

      if (e.logistic === 'green' && e.manage === 'green' && e.patgames === 'green') {
        e.global = 'green';
      } else if (e.logistic === 'red' && e.manage === 'red' && e.patgames === 'red') {
        e.global = 'red';
      } else {
        e.global = 'orange';
      }
    });
    state.statsEstablishments = establishments;
  },
  setStatsEstablishment(state, establishment) {
    establishment.forEach((e) => {
      e.participants = `${e.nbinvolvedparticipantsperiod}/${e.nballparticipants}`;
      e.reports = `${e.nbfinishedreports}/${e.nballreports}`;
      e.avglastsyn = e.avglastsyn ? parseInt(e.avglastsyn, 10) : '-';
      // logistique
      if (e.avglastsyn !== '-' && e.avglastsyn < 15 && e.nbsyncdevices === e.nballdevices) {
        e.logistic = 'green';
      } else if ((e.avglastsyn !== '-' && e.avglastsyn >= 15 && e.avglastsyn <= 30) || (e.nballdevices > 0 && e.nbsyncdevices / e.nballdevices >= 0.5)) {
        e.logistic = 'orange';
      } else if (e.avglastsyn === '-' || (e.avglastsyn > 30) || (e.nballdevices > 0 && e.nbsyncdevices / e.nballdevices < 0.5)) {
        e.logistic = 'red';
      }

      if (e.off_name === 'CLESIA' || (e.off_name).toUpperCase() === 'TOUT') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports === 0 || (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5)) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      } else if (e.off_name === 'PANACE') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      } else if (e.off_name === 'EGLE') {
        if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports > 0.75) {
          e.manage = 'green';
        } else if (e.nballreports > 0
          && e.nbfinishedreports / e.nballreports >= 0.5
          && e.nbfinishedreports / e.nballreports <= 0.75) {
          e.manage = 'orange';
        } else if (e.nballreports > 0 && e.nbfinishedreports / e.nballreports < 0.5) {
          e.manage = 'red';
        }

        if (e.nbpatgamessessions > 4) {
          e.patgames = 'green';
        } else if (e.nbpatgamessessions >= 1 && e.nbpatgamessessions <= 4) {
          e.patgames = 'orange';
        } else if (e.nbpatgamessessions < 1) {
          e.patgames = 'red';
        }
      }

      if (e.logistic === 'green' && e.manage === 'green' && e.patgames === 'green') {
        e.global = 'green';
      } else if (e.logistic === 'red' && e.manage === 'red' && e.patgames === 'red') {
        e.global = 'red';
      } else {
        e.global = 'orange';
      }
    });
    state.statsEstablishment = establishment;
  },
  setStatsDetailsEstablishment(state, establishment) {
    const manage = [];
    const patgames = [];

    for (let i = 0; i < 4; i += 1) {
      const period = moment().subtract(i + 1, 'month').format('YYYY-MM');
      manage.push({ year_month: period });
      patgames.push({ year_month: period });

      if (establishment[0].events && establishment[0].events.find(e => e.year_month === period)) {
        manage[i].nb_events = establishment[0].events.find(e => e.year_month === period).nb_events;
      } else {
        manage[i].nb_events = 0;
      }

      if (establishment[0].reports && establishment[0].reports.find(e => e.year_month === period)) {
        manage[i].reports = `${establishment[0].reports.find(e => e.year_month === period).finished_reports}/${establishment[0].reports.find(e => e.year_month === period).all_reports}`;
        manage[i].finished_reports = establishment[0].reports.find(e => e.year_month === period).finished_reports;
        manage[i].all_reports = establishment[0].reports.find(e => e.year_month === period).all_reports;
      } else {
        manage[i].reports = '0/0';
        manage[i].finished_reports = 0;
        manage[i].all_reports = 0;
      }

      if (establishment[0].sessions && establishment[0].sessions.find(e => e.year_month === period)) {
        manage[i].external_sessions = establishment[0].sessions.find(e => e.year_month === period).nb_external_sessions;
      } else {
        manage[i].external_sessions = 0;
      }

      if (establishment[0].activities && establishment[0].activities.find(e => e.year_month === period)) {
        patgames[i].nb_activities = establishment[0].activities.find(e => e.year_month === period).nb_activities;
      } else {
        patgames[i].nb_activities = 0;
      }

      if (establishment[0].sessions && establishment[0].sessions.find(e => e.year_month === period)) {
        patgames[i].nb_patgames = establishment[0].sessions.find(e => e.year_month === period).nb_patgames;
      } else {
        patgames[i].nb_patgames = 0;
      }

      if (establishment[0].participants && establishment[0].participants.find(e => e.year_month === period)) {
        patgames[i].participants = `${establishment[0].participants
          .find(e => e.year_month === period)
          .nbinvolvedparticipants}/${establishment[0].nb_all_participants}`;
      } else {
        patgames[i].participants = `${0}/${establishment[0].nb_all_participants}`;
      }

      if (establishment[0].sessions && establishment[0].sessions.find(e => e.year_month === period)) {
        patgames[i].time_patgames = establishment[0].sessions.find(e => e.year_month === period).time_patgames;
      } else {
        patgames[i].time_patgames = 0;
      }
    }

    manage.push({
      year_month: 'Total',
      nb_events: manage.reduce((a, b) => a + parseInt(b.nb_events, 10), 0),
      finished_reports: manage.reduce((a, b) => a + parseInt(b.finished_reports, 10), 0),
      all_reports: manage.reduce((a, b) => a + parseInt(b.all_reports, 10), 0),
      reports: `${manage.reduce((a, b) => a + parseInt(b.finished_reports, 10), 0)}/
      ${manage.reduce((a, b) => a + parseInt(b.all_reports, 10), 0)}`,
      external_sessions: manage.reduce((a, b) => a + b.external_sessions, 0),
    });

    patgames.push({
      year_month: 'Total',
      nb_activities: patgames.reduce((a, b) => a + parseInt(b.nb_activities, 10), 0),
      nb_patgames: patgames.reduce((a, b) => a + parseInt(b.nb_patgames, 10), 0),
      participants: establishment[0].nb_all_involved_participants ? `${establishment[0].nb_all_involved_participants}/
      ${establishment[0].nb_all_participants}` : `${0}/${establishment[0].nb_all_participants}`,
      time_patgames: patgames.reduce((a, b) => a + b.time_patgames, 0),
    });

    state.establishmentLogistic = establishment[0].syn;
    state.establishmentManage = manage;
    state.establishmentPatGames = patgames;
    state.statsDetailsEstablishment = establishment;
  },
  changeSlidingPeriodStatsEstablishments(state, period) {
    state.slidingPeriodStatsEstablishments = period;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
